import { render, staticRenderFns } from "./ModalCreateRequestQuote.vue?vue&type=template&id=b1222dfc"
import script from "./ModalCreateRequestQuote.vue?vue&type=script&lang=js"
export * from "./ModalCreateRequestQuote.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateRequestQuote.vue?vue&type=style&index=0&id=b1222dfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports